module.exports = __webpack_public_path__ + "img/tobias.edac802.jpg";